import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';

import OrganizationCard from './OrganizationCard';
import ContactInformationCard from './ContactInformationCard';
import UploadLogoCard from './UploadLogoCard';
import AddressCard from './AddressCard';
import PageSpinner from 'components/spinners/PageSpinner';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
  container: {
    margin: '0',
    maxWidth: '100%',
  },
  cardContainer: {
    width: '14rem',
    flexGrow: 1,
    flexShrink: 1,
  },
  uploadLogoContainer: {
    width: '14rem',
    flexGrow: 0,
    flexShrink: 0,
  },
}));

const OrganizationDetailsTab: React.FC = () => {
  const classes = useStyles();

  const organization = useSelector(
    (state: ApplicationState) => state.organization.organization,
  );

  return (
    <PageSpinner isLoading={organization === undefined}>
      <Grid container className={classes.container}>
        <Grid item className={classes.cardContainer}>
          <Grid
            container
            spacing={2}
            direction="column"
            className={classes.container}
          >
            <Grid item>
              <OrganizationCard />
            </Grid>

            <Grid item>
              <ContactInformationCard />
            </Grid>
          </Grid>
        </Grid>
        <Grid item className={classes.cardContainer}>
          <Grid
            container
            spacing={2}
            direction="column"
            className={classes.container}
          >
            <Grid item>
              <AddressCard />
            </Grid>
          </Grid>
        </Grid>
        <Grid item className={classes.uploadLogoContainer}>
          <Grid
            container
            spacing={2}
            direction="column"
            className={classes.container}
          >
            <Grid item xs={12}>
              <UploadLogoCard />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PageSpinner>
  );
};

export { OrganizationDetailsTab };
